export interface SavedPresetShareDTO {
  id: string;
  presetId: string;
  organizationId: string;
  sharedBy: string | null;
  createdAt: string;
}

export interface SavedPresetDTO {
  id: string;
  name: string;
  viewType: PresetViewType;
  preset: unknown;
  isDefault: boolean;
  isFavorite: boolean;
  updatedAt: string;
  share: SavedPresetShareDTO | null;
}

export enum PresetViewType {
  cohortMarketingPerformance = 'cohortMarketingPerformance',
  calendarInsights = 'calendarInsights',
  cohortChart = 'cohortChart',
  calendarChart = 'calendarChart',
  cohortRetention = 'cohortRetention',
  cohortScanner = 'cohortScanner',
  roiBreakdown = 'roiBreakdown',
}
